import React from "react";
import { Slide, SlideProps } from "@mui/material";
import { forwardRef, ReactElement } from "react";

export const SlideUpTransition = forwardRef<HTMLElement, SlideProps>(
    function Transition(props, ref) {
        return <Slide direction="up" ref={ref} {...props} />;
    }
);

export const SlideDownTransition = forwardRef<HTMLElement, SlideProps>(
    function Transition(props, ref) {
        return <Slide direction="down" ref={ref} {...props} />;
    }
);
